module.exports = __webpack_public_path__ + "img/u984.0f6f3ac4.jpg";